if (!customElements.get('mythic-subscription-selector')) {
  customElements.define('mythic-subscription-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.plans = JSON.parse(this.querySelector('[data-plans]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.monthlyPlans = JSON.parse(this.querySelector('[data-monthly-plans]')?.textContent || '{}');
      this.cards = Array.from(this.querySelectorAll('[data-coffee]'));
      this.counts = [0, 0, 0];
      this.active = Math.max(0, this.plans.findIndex(plan => String(plan.id) === this.dataset.productId));
      this.locked = Boolean(this.dataset.productId);
      const live = this.querySelector('[data-live-variants]');
      if (live) this.plans[this.active].variants = JSON.parse(live.textContent);
      this.querySelectorAll('[data-plan]').forEach(button => {
        button.hidden = this.locked && Number(button.dataset.plan) !== this.active;
      });
      if (this.locked) this.querySelector('.mythic-sub__plans').style.gridTemplateColumns = '1fr';
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        if (button.hasAttribute('data-plan') && !this.locked) {
          this.active = Number(button.dataset.plan);
          this.counts = [0, 0, 0];
          this.render();
        }
        if (button.hasAttribute('data-delta')) {
          const index = Number(button.closest('[data-coffee]').dataset.coffee);
          const delta = Number(button.dataset.delta);
          if ((delta === 1 && this.total < this.plan.limit) || (delta === -1 && this.counts[index] > 0)) {
            this.counts[index] += delta;
            this.render();
          }
        }
        if (button.hasAttribute('data-continue') && this.total === this.plan.limit && this.variant) {
          if (this.monthlyPlans[this.plan.id]) this.addSubscription();
          else this.querySelector('[data-confirmation]').hidden = false;
        }
      });
      this.render();
    }
    get plan() { return this.plans[this.active]; }
    get total() { return this.counts.reduce((sum, count) => sum + count, 0); }
    get variant() {
      const suffix = `-A${this.counts[0]}-N${this.counts[1]}-C${this.counts[2]}`;
      return this.plan.variants.find(variant => (variant.sku || '').endsWith(suffix));
    }
    async addSubscription() {
      if (this.busy || this.total !== this.plan.limit || !this.variant) return;
      const plan = this.plan;
      const selected = this.variant;
      const sellingPlan = String(this.monthlyPlans[plan.id] || '');
      if (!/^\d+$/.test(sellingPlan)) return;
      this.busy = true;
      this.render();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const currency = window.Shopify?.currency?.active || this.dataset.currency;
        if (currency !== this.dataset.currency) throw new Error('Currency mismatch');
        const response = await fetch(`${root}products/${encodeURIComponent(plan.handle)}.js`, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        const variant = product.variants.find(item => String(item.id) === String(selected.id));
        const allocation = variant?.selling_plan_allocations?.find(item => String(item.selling_plan_id) === sellingPlan);
        if (!variant?.available || variant.sku !== selected.sku || !allocation || Number(allocation.price) !== plan.price) throw new Error('Subscription unavailable');
        const added = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: selected.id, quantity: 1, selling_plan: sellingPlan}]})
        });
        if (!added.ok) throw new Error('Cart rejected');
        window.location.assign(`${root}cart`);
      } catch {
        this.busy = false;
        this.render();
        const message = this.querySelector('[data-confirmation]');
        message.textContent = this.labels.cart_error;
        message.hidden = false;
      }
    }
    render() {
      const total = this.total;
      const complete = total === this.plan.limit;
      this.querySelectorAll('[data-plan]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.plan) === this.active)));
      this.cards.forEach((card, index) => {
        card.dataset.selected = String(this.counts[index] > 0);
        card.querySelector('output').textContent = this.counts[index];
        card.querySelector('[data-delta="-1"]').disabled = Boolean(this.busy) || this.counts[index] === 0;
        card.querySelector('[data-delta="1"]').disabled = Boolean(this.busy) || total >= this.plan.limit;
      });
      const progress = this.querySelector('progress');
      progress.max = this.plan.limit;
      progress.value = total;
      const text = this.labels.progress.replace('{count}', total).replace('{total}', this.plan.limit);
      this.querySelector('[data-progress]').textContent = complete ? `${text} · ${this.labels.complete}` : text;
      this.querySelector('[data-selection]').textContent = this.cards.map((card, index) => this.counts[index] ? `${this.counts[index]} × ${card.querySelector('h3').textContent}` : '').filter(Boolean).join(' · ');
      this.querySelector('[data-price]').textContent = new Intl.NumberFormat(this.dataset.locale || 'es', {style: 'currency', currency: this.dataset.currency || 'EUR'}).format(this.plan.price / 100);
      this.querySelector('[data-variant]').value = complete && this.variant ? this.variant.id : '';
      this.querySelector('[data-continue]').disabled = Boolean(this.busy) || !complete || !this.variant;
      this.querySelector('[data-continue]').textContent = this.busy ? this.labels.adding : this.monthlyPlans[this.plan.id] ? this.labels.cart : this.labels.preview;
      this.querySelector('[data-confirmation]').hidden = true;
      if (complete && !this.variant) this.querySelector('[data-progress]').textContent = this.labels.error;
    }
  });
}

